import styled from "styled-components/macro";

const PaddedIcon = styled.div`
  cursor: pointer;
  display: flex;
  padding: 12px;
  align-items: center;
  justify-content: center;
  ${({ theme }) => `${theme.active}`}
`;

export default PaddedIcon;
